import { useState } from 'react'

export const ProductState = () => {
    const [form, setForm] = useState({quantity: 1, last_name: '', first_name: '', contact_number:'', email: '', delivery_option: 'delivery', address: '', place_id: '', landmark: '', is_default: 0, date: '', time: '', remarks: '', pickup_time:'' , pickup_date:'', dragonpay: true,  sub_total: 0, total_amount: 0, shipping_fee: 0, shipping_id: '', payment_opt: 'full', payment_method: 'GCSH' })
    const [promoPage, setPromoPage] = useState([])
    const [viewLoader, setViewLoader] = useState(true)
    const [error, setError] = useState(false)
    const [confirmation, setConfirmation] = useState(false)
    const [btnLoader, setBtnLoader] = useState(false)
    const [city, setCity] = useState([])
    const [brgy, setBrgy] = useState([])
    const [ship, setShip] =useState([])
    const [orderList, setOrderList] = useState([])
    const [loaderList, setLoaderList] = useState(false)
    const [showdetails, setShowDetails] = useState(false)
    const [receipt, setReceipt] = useState(null)
    const [prodList, setProdList] = useState(false)
    const [loader, setLoader] = useState(true)
    const [inftScroll, setInftScroll] = useState(true)
    const [lid, setLid] = useState()
    const [search, setSearch] = useState('')
    const [dtError, setDtError] = useState({date: false, time: false})
    const [confirmId, setConfirmId] = useState()
    const [review, setReview] = useState({ overall: 0, product_rate: 0, product_remarks: '', seller_rate: 0, seller_remarks: '', shipping_rate: 0, shipping_remarks: '', files: [], btnLoader: false, error: false, type: 'create', viewLoader: false, })
    const [fileMsg, setFileMsg] = useState('')
    const [viewImg, setViewImg] = useState({show: false, index: 0})
    const [promoDetails, setPromoDetails] = useState({info: '', reviews: [], loader: true, reviews_count: 0})
    const [storeItems, setStoreItems] = useState([])
    const [reviewsList, setReviewsList] = useState([])
    const [showMyDiscount, setShowMyDiscount] = useState(false)
    const [discountList, setDiscountList] = useState([])
    const [toExpire, setToExpire] = useState('')
    const [shippingRate, setShippingRate] = useState('')
    const [deliveryAddresses, setDeliveryAddresses] = useState([]);
    const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(null);
    const [productImg, setProductImg] = useState()

    return {
        form: {data: form, set: setForm},
        promoPage: {data: promoPage, set: setPromoPage},
        viewLoader: {data: viewLoader, set: setViewLoader},
        error: {data: error, set: setError},
        confirmation: {data: confirmation, set: setConfirmation},
        btnLoader: {data: btnLoader, set: setBtnLoader},
        city: {data: city, set: setCity},
        brgy: {data: brgy, set: setBrgy},
        ship: {data: ship, set: setShip},
        orderList: {data: orderList, set: setOrderList},
        loaderList: {data: loaderList, set: setLoaderList},
        showdetails: {data: showdetails, set: setShowDetails},
        receipt: {data: receipt, set: setReceipt},
        prodList: {data: prodList, set: setProdList},
        loader: {data: loader, set: setLoader},
        inftScroll: {data: inftScroll, set: setInftScroll},
        lid: {data: lid, set: setLid},
        search: {data: search, set: setSearch},
        dtError: {data: dtError, set: setDtError},
        confirmId: {data: confirmId, set: setConfirmId},
        review: {data: review, set: setReview},
        fileMsg: {data: fileMsg, set: setFileMsg},
        viewImg: {data: viewImg, set: setViewImg},
        promoDetails: {data: promoDetails, set: setPromoDetails},
        storeItems: {data: storeItems, set: setStoreItems},
        reviewsList: {data: reviewsList, set: setReviewsList},
        showMyDiscount: {data: showMyDiscount, set: setShowMyDiscount},
        discountList: {data: discountList, set: setDiscountList},
        toExpire: {data: toExpire, set: setToExpire},
        shippingRate: {data: shippingRate, set: setShippingRate},
        deliveryAddresses: {data: deliveryAddresses, set: setDeliveryAddresses},
        selectedDeliveryAddress: {data: selectedDeliveryAddress, set: setSelectedDeliveryAddress},
        productImg: {data: productImg, set: setProductImg},
    }
}
